import React, { useState, Suspense, useEffect } from "react";
import "./Header.css";
import { Menubar } from "primereact/menubar";
import SideNav from "../sidebar/SideNav";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import settings from "../../config/settings";

type HeaderProps = {
  userDetails: any;
};
const Navbar = (props: HeaderProps) => {
  const { t } = useTranslation();

  const [username, setUsername] = useState<any>("");
  const languages = [
    { label: "English", value: "en" },
    { label: "Deutsch", value: "de" },
  ];
  const [selectedLanguage, setLanguage] = useState<string>("en");

  const onLanguageChange = (e: any) => {
    setLanguage(e.value);
  };

  const logout = () => {
      const currentUrl = window.location.href;
      const keycloakIdToken = localStorage.getItem('keycloak-id-token');
      window.location.href = settings.logoutUrl
          + '?id_token_hint=' + keycloakIdToken
          + '&post_logout_redirect_uri=' + currentUrl;
  };

  const start = <SideNav />;
  const end = (
    <div className="flex my-3">
      <ul className="pr-5">
        <li>
          <div className="profile">
            <i className="pi pi-user p-0 m-0"></i>
            {/* <a className="name">{username}</a> */}
            <ul className="menu">
              {/*<li>*/}
              {/*  <p>Companies</p>*/}
              {/*  <ul>*/}
              {/*    <li>Company 1</li>*/}
              {/*  </ul>*/}
              {/*</li>*/}
              <li>
                <Link to={"/settings"}>
                  <p>{t("settings")}</p>
                </Link>
              </li>
              <li>
                <Link to={"/all-devices/"} onClick={()=>{localStorage.setItem('redirect-url',"/all-devices/")}}>
                  <p>{t("devices")}</p>
                </Link>
              </li>
              <li>
                <p onClick={logout}>{t("logout")}</p>
              </li>
            </ul>
          </div>
        </li>
      </ul>

    </div>
  );

  useEffect(() => {
    setUsername(
      props["userDetails"]["first_name"] +
        " " +
        props["userDetails"]["last_name"]
    );
  });

  return (
    <Suspense fallback="Loading.....">
      <div className="card relative">
        <Menubar start={start} end={end}  />
        <div style={{position:'absolute', top:'13px', left:0, right:0, margin:'0 auto', width:'200px'}}><p className="text-center d-inline">
          <img src="/images/vibbase-logo.png" alt="Vibbase Logo" width={150}/>
        </p></div>
      </div>
    </Suspense>
  );
};

export default Navbar;
